<template>
    <div class="colors_page">
        <div class="container">
            <div class="build_list_top">
                <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
                <div class="right_link">
                    <router-link :to="{ name: 'Myorder' }">
                        Back to My Account
                    </router-link>
                </div>
            </div>

            <section class="order-build-section pt-0">
                <div class="row">
                    <div class="col-md-6">
                        <h3 class="page-title">
                            My Builds ( {{ totalRows }} )
                        </h3>
                    </div>
                    <div class="col-md-6">
                        <div class="float-right short_by">
                            <div class="select_option sec_opt mb-0">
                                <label>Status</label>
                                <fieldset>
                                    <v-select
                                        label="label"
                                        :reduce="(sorting) => sorting.id"
                                        v-model="listConfig.status"
                                        :options="sorting_array"
                                        :placeholder="'Build Status'"
                                    >
                                    </v-select>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="build-block">
                    <div class="build-table">
                        <table width="100%">
                            <thead>
                                <tr class="table_head">
                                    <th>Build Name</th>
                                    <th>Number Location</th>
                                    <th>Orders</th>
                                    <th>Color Set</th>
                                    <th>Last Order</th>
                                    <th>Build Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(build, index) in totalBuildList"
                                    :key="index"
                                >
                                    <td>
                                        <router-link
                                            :to="{
                                                name: 'BuildDetailsV3',
                                                params: { id: build.id }
                                            }"
                                        >
                                            {{ build.name | capitalize }}
                                        </router-link>
                                    </td>
                                    <td>
                                        {{
                                            build.no_of_locations
                                                ? build.no_of_locations
                                                : "0"
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            build.no_of_orders
                                                ? build.no_of_orders
                                                : "0"
                                        }}
                                    </td>
                                    <td class="color_data">
                                        <ul
                                            v-show="
                                                build.total_colors != 'null'
                                            "
                                        >
                                            <li
                                                v-for="(
                                                    color1, index1
                                                ) in build.total_colors"
                                                :style="
                                                    'background-color:' +
                                                    color1.hex +
                                                    ';'
                                                "
                                                :key="index1"
                                                v-show="hasLimit(build, index1)"
                                                v-tooltip="{
                                                    content: color1.name
                                                        ? `${color1.name}<br/>${color1.hex}`
                                                        : color1.hex,
                                                    html: true
                                                }"
                                            ></li>
                                            <li
                                                v-show="
                                                    build.total_colors.length >
                                                    colors_limit
                                                "
                                                class="more_color_link"
                                                @click="
                                                    build.is_color_show_more =
                                                        !build.is_color_show_more
                                                "
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    v-if="
                                                        build.is_color_show_more
                                                    "
                                                    >-</a
                                                >
                                                <a
                                                    href="javascript:void(0);"
                                                    v-else
                                                    >+{{
                                                        build.total_colors
                                                            .length -
                                                        colors_limit
                                                    }}</a
                                                >
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        {{
                                            build.last_order_date
                                                ? new Date(
                                                      build.last_order_date
                                                  ).toLocaleString()
                                                : "-"
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            build.status == "1"
                                                ? "Active"
                                                : build.active == "0"
                                                ? "Inactive"
                                                : "Archived"
                                        }}
                                    </td>
                                    <td>
                                        <table class="links_block">
                                            <tr>
                                                <td>
                                                    <a
                                                        href="javascript:void(0);"
                                                        @click="
                                                            changeBuildName(
                                                                build.id
                                                            )
                                                        "
                                                        >Clone</a
                                                    >
                                                </td>
                                                <td>
                                                    <router-link
                                                        :to="{
                                                            name: 'BuildDetailsV3',
                                                            params: {
                                                                id: build.id
                                                            }
                                                        }"
                                                        >View</router-link
                                                    >
                                                </td>
                                                <td>
                                                    <router-link
                                                        :class="{
                                                            'disabled text-muted':
                                                                !build.last_order_id
                                                        }"
                                                        :to="{
                                                            name: 'Order_detail',
                                                            params: {
                                                                id: build.last_order_id
                                                            }
                                                        }"
                                                        >Order</router-link
                                                    >
                                                </td>
                                                <td>
                                                    <a
                                                        href="javascript:void(0);"
                                                        @click="
                                                            addToArchive(
                                                                build.id,
                                                                build.status
                                                            )
                                                        "
                                                        >{{
                                                            build.status == "1"
                                                                ? "Archive"
                                                                : "Active"
                                                        }}</a
                                                    >
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>

                                <tr v-if="!totalBuildList.length > 0">
                                    <td colspan="7" class="text-center">
                                        No Build Found...
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div
                            class="pagination_margin productlist_pagination_custom mt-4"
                            v-if="totalBuildList.length"
                        >
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="itemsPerPage"
                                class="imprint_pagination"
                            ></b-pagination>
                        </div>
                    </div>
                    <div class="add_build_button">
                        <router-link
                            class="btn btn_orange btn btn_orange bg_primary_orange text_white py_18 px_64 ml_20"
                            :to="{ name: 'DesignStudioV3' }"
                        >
                            ADD Build</router-link
                        >
                    </div>
                </div>
            </section>
        </div>
        <!-- Saved Design Modal -->
        <div
            class="modal login-form-popup fade h-auto"
            id="clone_build"
            tabindex="-1"
            aria-labelledby="design-studio"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Save Clone Build</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form
                        method="post"
                        @submit.prevent="cloneOrderBuild"
                        data-vv-scope="addshapeform"
                    >
                        <div class="modal-body">
                            <div class="">
                                <label for="inputPassword5"
                                    >Enter Clone Build Title Name</label
                                >
                                <input
                                    type="text"
                                    v-model="clone_build_name"
                                    name="Design name"
                                    required="required"
                                    placeholder="Enter New Build Title Name"
                                    value=""
                                    class="form-control"
                                />

                                <small
                                    class="form-text text-error text-left"
                                    v-show="
                                        errors.has('addshapeform.Design name')
                                    "
                                >
                                    {{
                                        errors.first("addshapeform.Design name")
                                    }}
                                </small>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn_white border border-primary text_blue mt_20 mb_10 btn_h60"
                                data-dismiss="modal"
                            >
                                CANCEL
                            </button>
                            <button
                                type="submit"
                                class="add_cart btn btn_orange bg_primary_orange text_white mt_20 mb_10 btn_h60"
                                data-original-title=""
                                title=""
                            >
                                save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import Breadcrumb from "@/components/Breadcrumb";

export default {
    name: "BuildList",
    components: {
        Breadcrumb
    },
    data() {
        return {
            isLoader: false,
            totalBuildList: [],
            clone_build_name: "",
            clone_build_id: "",
            breadcrumbs: [],
            colors_limit: 4,
            totalRows: 0,
            itemsPerPage: 5,
            currentPage: 1,
            listConfig: {
                limit: this.itemsPerPage,
                offset: (this.currentPage - 1) * this.itemsPerPage,
                sortBy: "id",
                order: "DESC",
                status: "All"
            },
            sorting_array: [
                {
                    id: "0",
                    label: "All"
                },
                {
                    id: "1",
                    label: "Active"
                },
                {
                    id: "2",
                    label: "Archived"
                }
            ]
        };
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getAllBuildList();
        },
        "listConfig.status": function (newValue) {
            this.listConfig.status = newValue;
            this.getAllBuildList();
        }
    },
    mounted() {
        this.breadcrumbs = [
            { name: `Design Studio`, url: "/design-studio/v3" },
            { name: `Build Listing` }
        ];
        this.listConfig.limit = this.itemsPerPage;
        this.listConfig.offset = (this.currentPage - 1) * this.itemsPerPage;
        this.getAllBuildList();
    },
    methods: {
        getAllBuildList() {
            let _this = this;
            _this.isLoader = true;
            ApiService.post("/get-build-list", this.listConfig)
                .then(({ data }) => {
                    let buildList = [];

                    this.totalRows = data.build.count;

                    if (data.build.rows) {
                        data.build.rows.forEach((item) => {
                            item.is_color_show_more = false;
                            let total_build_colors = [];
                            let copied_total_colors = item.total_colors
                                ? JSON.parse(item.total_colors)
                                : [];
                            copied_total_colors.forEach((color) => {
                                let color_existed_index =
                                    total_build_colors.findIndex(
                                        (col) => col.hex == color.hex
                                    );
                                if (color_existed_index == -1) {
                                    total_build_colors.push(color);
                                }
                            });
                            item.total_colors = total_build_colors;
                            buildList.push(item);
                        });
                    }
                    _this.totalBuildList = buildList;
                    _this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                    _this.isLoader = false;
                });
        },
        hasLimit(build, index) {
            if (!build.is_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },
        changeBuildName(order_build_id) {
            this.clone_build_id = order_build_id;
            /* eslint-disable */
            $("#clone_build").modal("show");
            /* eslint-enable */
        },
        cloneOrderBuild() {
            let _this = this;
            _this.isLoader = true;
            ApiService.post("/clone-build/", {
                name: _this.clone_build_name,
                id: _this.clone_build_id
            })
                .then(({ data }) => {
                    _this.$toast.success(data.message, {
                        position: "top-right",
                        queue: true
                    });
                    /* eslint-disable */
                    $("#clone_build").modal("hide");
                    /* eslint-enable */
                    _this.getAllBuildList();
                    _this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                    _this.isLoader = false;
                });
        },
        addOrder() {},
        addToArchive(order_build_id, status) {
            let _this = this;
            _this.isLoader = true;
            ApiService.get(
                "/update-build-status/" + order_build_id + "/" + status
            )
                .then(({ data }) => {
                    _this.$toast.success(data.message, {
                        position: "top-right",
                        queue: true
                    });
                    _this.getAllBuildList();
                    _this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                    _this.isLoader = false;
                });
        },
        deleteBuild(order_build_id) {
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ApiService.delete("/delete-saved-design/" + order_build_id)
                        .then(() => {
                            this.$toast.success(
                                "Order Build deleted successfully",
                                {
                                    position: "top-right"
                                }
                            );
                            this.getAllBuildList();
                        })
                        .catch(() => {});
                });
            }
        }
    }
};
</script>
